/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../Loader';
import useDebounce from '../../../utils/useDebounce';

const UnregisteredPayments = (props) => {
  const {
    setEmail,
    setName,
    setPurchaseId,
    setProvider,
    setStartDate,
    setFinishDate,
    setCountry,
    handleFetchCollatedPayments,
    fetchCollatedPaymentsInProgress,
    handleDownload,
    handleDownloadAll,
    downloadingInProgress,
    downloadingAllInProgress,
  } = props;
  const className = {};

  const [emailSearch, setEmailSearch] = useState('');
  const debouncedEmail = useDebounce(emailSearch, 500);
  useEffect(() => {
    setEmail(emailSearch);
  }, [debouncedEmail]);

  const [nameSearch, setNameSearch] = useState('');
  const debouncedName = useDebounce(nameSearch, 500);
  useEffect(() => {
    setName(nameSearch);
  }, [debouncedName]);

  const [purchaseIdSearch, setPurchaseIdSearch] = useState('');
  const debouncedPurchaseId = useDebounce(purchaseIdSearch, 500);
  useEffect(() => {
    setPurchaseId(purchaseIdSearch);
  }, [debouncedPurchaseId]);

  const [countrySearch, setCountrySearch] = useState('');
  const debouncedCountry = useDebounce(countrySearch, 500);
  useEffect(() => {
    setCountry(countrySearch);
  }, [debouncedCountry]);

  const [startDateSearch, setStartDateSearch] = useState('');
  const debouncedStartDate = useDebounce(startDateSearch, 500);
  useEffect(() => {
    const date = new Date(new Date(startDateSearch).toDateString());
    if (startDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setStartDate(startDateSearch);
    }
  }, [debouncedStartDate]);

  const [finishDateSearch, setFinishDateSearch] = useState('');
  const debouncedFinalDate = useDebounce(finishDateSearch, 500);
  useEffect(() => {
    const date = new Date(new Date(finishDateSearch).toDateString());
    if (finishDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setFinishDate(finishDateSearch);
    }
  }, [debouncedFinalDate]);

  return (
    <div className="flex">
      <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Provider
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={newValue => setProvider(newValue.currentTarget.value)}
          >
            <option value="" />
            <option value="stripe">Stripe</option>
            <option value="paypal">Paypal</option>
            <option value="free">Free</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="emailSearch"
        >
          Email
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="emailSearch"
          type="text"
          onChange={e => setEmailSearch(e.target.value)}
          value={emailSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="nameSearch"
        >
          Name
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="nameSearch"
          type="text"
          onChange={e => setNameSearch(e.target.value)}
          value={nameSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="purchaseIdSearch"
        >
          purchaseId
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="purchaseIdSearch"
          type="text"
          onChange={e => setPurchaseIdSearch(e.target.value)}
          value={purchaseIdSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="countrySearch"
        >
          Country
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="countrySearch"
          type="text"
          onChange={e => setCountrySearch(e.target.value)}
          value={countrySearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="startDateSearch"
        >
          Start Date
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="startDateSearch"
          placeholder="yyyy-mm-dd"
          type="text"
          onChange={e => setStartDateSearch(e.target.value)}
          value={startDateSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="finishDateSearch"
        >
          Final Date
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="finishDateSearch"
          placeholder="yyyy-mm-dd"
          type="text"
          onChange={e => setFinishDateSearch(e.target.value)}
          value={finishDateSearch}
        />
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleFetchCollatedPayments}>
          { !fetchCollatedPaymentsInProgress && 'Fetch new' }
          { fetchCollatedPaymentsInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleDownload}>
          { !downloadingInProgress && 'Download filtered' }
          { downloadingInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleDownloadAll}>
          { !downloadingAllInProgress && 'Download all' }
          { downloadingAllInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      {/* <Grid
        className={classes.range}
        item
        lg={3}
        sm={6}
        xl={3}
        xs={12}
        m={2}
      >
        <Typography id="range-slider">
          Order price range
        </Typography>
        <Slider
          value={rangeValue}
          onChange={handleChangeRange}
          onChangeCommitted={setRangeFilter}
          aria-labelledby="range-slider"
          valueLabelDisplay="auto"
          min={0}
          max={2000}
        />
      </Grid> */}
    </div>
  );
};

UnregisteredPayments.propTypes = {
  setEmail: PropTypes.func.isRequired,
  setName: PropTypes.func.isRequired,
  setProvider: PropTypes.func.isRequired,
  setPurchaseId: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setFinishDate: PropTypes.func.isRequired,
  setCountry: PropTypes.func.isRequired,
  handleFetchCollatedPayments: PropTypes.func.isRequired,
  fetchCollatedPaymentsInProgress: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func.isRequired,
  handleDownloadAll: PropTypes.func.isRequired,
  downloadingInProgress: PropTypes.bool.isRequired,
  downloadingAllInProgress: PropTypes.bool.isRequired,
};

UnregisteredPayments.defaultProps = {
  // renewSubscription: null,
  // couponCode: null,
  // userId: null,
  // name: null,
  // present: null,
  // productSlugName: null,
  // productType: null,
  // provider: null,
  // startDate: null,
  // finishDate: null,
};

export default UnregisteredPayments;
